import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "react-apollo";
import { useRefetchableQuery } from "core/hooks/useRefetchableQuery";
import {
  GetSchedulerMetricsVariables as GetScheduleMetricsVariablesGenerated,
  GetSchedulerMetrics as GetSchedulerMetricsGenerated,
  GetSchedulerMetrics_taskSchedulerMetrics as TaskSchedulerMetricsGenerated,
} from "core/queries/__generated__/GetSchedulerMetrics";

export interface GetSchedulerMetricsResponse
  extends GetSchedulerMetricsGenerated {}

export interface GetSchedulerMetricsVariables
  extends GetScheduleMetricsVariablesGenerated {}

export interface TaskSchedulerMetrics extends TaskSchedulerMetricsGenerated {}

export const GetSchedulerMetrics = gql`
  query GetSchedulerMetrics($filters: SchedulerMetricsFilterInput!) {
    taskSchedulerMetrics(filters: $filters) {
      totalAssignees {
        avatar {
          id
          url
        }
        name
        id
      }
      totalBaths
      totalBeds
      totalBedTypes {
        label
        value
      }
      totalCleans
      totalCleanTypes {
        label
        value
      }
      totalCompletedCleans
      totalInProgressCleans
      totalReadyCleans
      totalHours
      totalScheduledCleans
      totalUnscheduledCleans
    }
  }
`;

interface GetSchedulerMetricsQueryOptions
  extends QueryHookOptions<
    GetSchedulerMetricsResponse,
    GetSchedulerMetricsVariables
  > {}

export const useGetSchedulerMetrics = (
  options?: GetSchedulerMetricsQueryOptions,
) => {
  return useQuery<GetSchedulerMetricsResponse, GetSchedulerMetricsVariables>(
    GetSchedulerMetrics,
    options,
  );
};

export const useRefetchableGetSchedulerMetricsQuery = ({
  notifyOnNetworkStatusChange,
  pollInterval,
  skip,
  variables,
}: GetSchedulerMetricsQueryOptions) =>
  useRefetchableQuery<
    GetSchedulerMetricsResponse,
    GetSchedulerMetricsVariables
  >(GetSchedulerMetrics, {
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange,
    pollInterval,
    skip,
    variables,
  });
